import { numericExtent, acSeries } from "../utils";
const AC = {
    name: "AC",
    compute: (bars) => acSeries(bars),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default AC;
